// extracted by mini-css-extract-plugin
module.exports = {"description":"LoginView__description","container":"LoginView__container","iconContainer":"LoginView__iconContainer","phonesIcon":"LoginView__phonesIcon"};